<template>
<div id="app">
  <div class="navbar navbar-vertical fixed-start navbar-expand-md navbar-light" id="sidebar">
    <div data-simplebar class="navbar-simplebar">
      <!-- Brand -->
      <a class="navbar-brand" href="./index.html">
          <img src="assets/img/gaspol-ptn-logo-dark.svg" class="navbar-brand-img mx-auto" alt="...">
      </a>

      <!-- Collapse -->
      <div class="collapse navbar-collapse" id="sidebarCollapse">
          <div class="d-flex align-items-center overflow-hidden border-top border-bottom py-3">
              <div class="d-block me-2">
                  <div class="block-image block-image-md-avatar rounded-circle me-3 bg-transparent" style="background-image: url('assets/img/gaspol-avatar-2.jpg');"></div>
              </div>
              <div class="d-block overflow-hidden">
                  <div class="block-ellipsis h4">{{ users.fullname }}</div>
                  <div class="d-block px-1">
                      <button type="button" class="btn btn-sm btn-white btn-s-1" v-on:click="signout">
                          <div class="btn-s-1-inner"><i class="fa-solid fa-arrow-right-from-bracket me-2"></i>Keluar</div>
                      </button>
                  </div>
              </div>
          </div>
          <!-- Navigation -->
          <ul class="navbar-nav navbar-nav-style-1 mt-3">
              <li class="nav-item" v-for="(item, index) in dataMenu" :key="index">
                  <router-link v-if="item.parent == 0" class="nav-link" :to="{ name: item.url}" :class="activeClass == item.url ? 'active':''" @click.native="setCurrent(item.url)">
                    <i :class="item.icon"></i>{{ item.name }}
                  </router-link>

                  <a v-if="item.parent == 1" class="nav-link" :href="'#'+item.code" data-bs-toggle="collapse" role="button" aria-expanded="false" :aria-controls="item.code" :class="item.url.includes(activeClass) ? 'active': ''">
                      <i :class="item.icon"></i>{{ item.name }}
                  </a>

                  <div v-if="item.parent == 1" class="collapse sub-nav-link" :id="item.code" :class="item.url.includes(activeClass) ? 'collapse show': ''">
                      <ul class="nav nav-sm flex-column">
                          <li class="nav-item" v-for="(subMenu, indexSubMenu) in item.sub_menu" :key="indexSubMenu">
                              <router-link :to="{ name: subMenu.url}" class="nav-link" @click.native="setCurrent(subMenu.url)" :class="activeClass == subMenu.url ? 'active':''">
                                  {{ subMenu.name }}
                              </router-link>
                          </li>
                      </ul>
                  </div>
              </li>
          </ul>
          <!-- Push content down -->
          <div class="mt-auto"></div>

          <!-- Build info -->
          <div class="d-block text-center text-muted border-top pt-3 pb-2 app-version" :title="'Build: ' + appInfo.buildDate">
              <div class="d-block">v{{ appInfo.version }}<span v-if="appInfo.commit"> · {{ appInfo.commit }}</span></div>
              <div class="d-block">{{ appInfo.buildDate }}</div>
          </div>
      </div>
    </div>
  </div>
  <img src="assets/img/bg-element-2.png" class="bg-element-1">
  <div class="main-content overflow-hidden">
    <slot/>
  </div>
  
  <SchoolForm ref="school_form"/>
  <UniversityForm ref="university_form"/>
  <MasterMajorForm ref="master_major_form"/>
  <SubjectForm ref="subject_form"/>
  <GroupSubjectForm ref="group_subject_form"/>
  <MajorForm ref="major_form"/>
  <PassingGradeLimitForm ref="passing_grade_limit_form"/>
  <PassingGradeAlumniForm ref="passing_grade_alumni_form"/>
  <PassingGradeAlumniDetail ref="passing_grade_alumni_detail"/>
  <PassingGradeAlumniUtbkForm ref="passing_grade_alumni_utbk_form"/>
  <PassingGradeAlumniUtbkDetail ref="passing_grade_alumni_utbk_detail"/>
  <PassingGradeMajorForm ref="passing_grade_major_form"/>
  <AchievementForm ref="achievement_form"/>
  <SchoolPartnerForm ref="school_partner_form"/>
  <SchoolPartnerDetail ref="school_partner_detail"/>
  <UsersForm ref="users_form"/>
  <UsersPasswordForm ref="users_password_form"/>
  <EligibleSchoolForm ref="eligible_school_form"/>
    <div class="modal" id="modal-with-progress-bar" tabindex="-1" role="dialog" aria-hidden="true" data-bs-backdrop="static">
        <div class="modal-dialog modal-dialog-centered" role="document">
            <div class="modal-content">
                <div class="modal-header align-items-center">
                    <h3 class="modal-title my-0">{{ dataModalWithProgressBar.title }}</h3>
                    <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close" v-if="dataModalWithProgressBar.withClose"></button>
                </div>
                <div class="modal-body">
                    <div class="d-block text-center">
                        <div class="mb-3">
                            <p class="text-muted">{{ dataModalWithProgressBar.subtitle }}</p>
                        </div>
                        <div class="d-flex gap-3 align-items-center mb-3">
                            <div class="progress flex-grow-1" role="progressbar" aria-valuenow="0" aria-valuemin="0" aria-valuemax="100">
                                <div class="progress-bar progress-bar-striped progress-bar-animated" :style="{ width: dataModalWithProgressBar.progress + '%' }"></div>
                            </div>
                            <div class="d-block text-sm fw-bold" :class="{'text-danger': dataModalWithProgressBar.progress > 0 && dataModalWithProgressBar.progress < 30, 'text-warning': dataModalWithProgressBar.progress >= 30 && dataModalWithProgressBar.progress < 50, 'text-info': dataModalWithProgressBar.progress >= 50 && dataModalWithProgressBar.progress < 80, 'text-neon': dataModalWithProgressBar.progress >= 80}">
                                <span>{{ dataModalWithProgressBar.progress }}%</span>
                            </div>
                        </div>
                        <button type="button" class="btn btn-sm btn-white" data-bs-dismiss="modal" v-if="dataModalWithProgressBar.withClose">Tutup Informasi</button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
</template>


<script>
  import SchoolForm from '../views/school/form.vue'
  import UniversityForm from '../views/university/form.vue'
  import MasterMajorForm from '../views/master_major/form.vue'
  import SubjectForm from '../views/subject/form.vue'
  import GroupSubjectForm from '../views/group-subject/form.vue'
  import MajorForm from '../views/major/form.vue'
  import PassingGradeLimitForm from '../views/major/passing-grade-limit-form.vue'
  import PassingGradeAlumniForm from '../views/passing-grade-alumni/form.vue'
  import PassingGradeAlumniDetail from '../views/passing-grade-alumni/detail.vue'
  import PassingGradeAlumniUtbkForm from '../views/passing-grade-alumni-utbk/form.vue'
  import PassingGradeAlumniUtbkDetail from '../views/passing-grade-alumni-utbk/detail.vue'
  import PassingGradeMajorForm from '../views/passing-grade-major/form.vue'
  import AchievementForm from '../views/achievement/form.vue'
  import SchoolPartnerForm from '../views/school/form-partner.vue'
  import SchoolPartnerDetail from '../views/school/detail-partner.vue'
  import UsersForm from '../views/users/form.vue'
  import UsersPasswordForm from '../views/users/password.vue'
  import EligibleSchoolForm from '../views/eligible-school/form.vue'

  export default {
    name: 'MainLayout',
    components: {
        SchoolForm,
        UniversityForm,
        MasterMajorForm,
        SubjectForm,
        GroupSubjectForm,
        MajorForm,
        PassingGradeLimitForm,
        PassingGradeAlumniForm,
        PassingGradeAlumniDetail,
        PassingGradeAlumniUtbkForm,
        PassingGradeAlumniUtbkDetail,
        PassingGradeMajorForm,
        AchievementForm,
        SchoolPartnerForm,
        SchoolPartnerDetail,
        UsersForm,
        UsersPasswordForm,
        EligibleSchoolForm
    },
    data() {
        return {
            activeClass     : this.$route.name,
            activeMenu      : "",
            activeSubMenu   : "",
            lastMenu        : "",
            dataMenu        : [],
            users           : [],
            appInfo         : {
                version   : process.env.VUE_APP_VERSION,
                commit    : process.env.VUE_APP_COMMIT,
                buildDate : process.env.VUE_APP_BUILD_DATE
            },
            dataModalWithProgressBar: {
                title: '',
                subtitle: '',
                progress: 0,
                withClose: true,
                action : async () => {}
            }
        }
    },
    created() {
        this.getMenu();
        this.getUsers();
    },
    methods: {
        setCurrent: function(params = "") {
            this.activeClass    = params;
        },
        getMenu: function() {
            let uri = process.env.VUE_APP_APIHOST+'users/menu';
            
            this.$http.get(uri).then(response => {
                this.dataMenu   = response.data.list_menu;
                this.lastMenu   = response.data.last_menu;
            });
        },
        getUsers: function() {
            let uri = process.env.VUE_APP_APIHOST+'users/info';
            
            this.$http.get(uri).then(res => {
                this.users = res.data;
            });
        },
        signout: function() {
            this.$router.push({ name : 'signout'})
        },
        school_form: function(params="") {
            this.$refs.school_form.loadForm(params);
        },
        university_form: function(params="") {
            this.$refs.university_form.loadForm(params);
        },
        master_major_form: function(params="") {
            this.$refs.master_major_form.loadForm(params);
        },
        subject_form: function(params="") {
            this.$refs.subject_form.loadForm(params);
        },
        group_subject_form: function(params="") {
            this.$refs.group_subject_form.loadForm(params);
        },
        major_form: function(params="") {
            this.$refs.major_form.loadForm(params);
        },
        passing_grade_limit_form: function() {
            this.$refs.passing_grade_limit_form.loadForm();
        },
        passing_grade_alumni_form: function(params="") {
            this.$refs.passing_grade_alumni_form.loadForm(params);
        },
        passing_grade_alumni_detail: function(params) {
            this.$refs.passing_grade_alumni_detail.loadForm(params);
        },
        passing_grade_alumni_utbk_form: function(params="") {
            this.$refs.passing_grade_alumni_utbk_form.loadForm(params);
        },
        passing_grade_alumni_utbk_detail: function(params) {
            this.$refs.passing_grade_alumni_utbk_detail.loadForm(params);
        },
        passing_grade_major_form: function(params="") {
            this.$refs.passing_grade_major_form.loadForm(params);
        },
        achievement_form: function(params="") {
            this.$refs.achievement_form.loadForm(params);
        },
        school_partner_form: function() {
            this.$refs.school_partner_form.loadForm();
        },
        school_partner_detail: function(params, role) {
            this.$refs.school_partner_detail.loadForm(params, role);
        },
        users_form: function(role, params) {
            this.$refs.users_form.loadForm(role, params);
        },
        users_password_form: function(params) {
            this.$refs.users_password_form.loadForm(params);
        },
        eligible_school_form: function(params="") {
            this.$refs.eligible_school_form.loadForm(params);
        },
        openModalWithProgressBar: function(data) {
            this.dataModalWithProgressBar.title       = data.title;
            this.dataModalWithProgressBar.subtitle    = data.subtitle;
            this.dataModalWithProgressBar.progress    = 0;
            this.dataModalWithProgressBar.action      = data.action;
            this.dataModalWithProgressBar.withClose   = data.withClose || false;

            this.startProgressBar();
        },
        startProgressBar: function() {
            if (typeof this.dataModalWithProgressBar.action === "function") {
                this.dataModalWithProgressBar.action();
            }
        },
        updateTitleModalWithProgressBar: function(title) {
            this.dataModalWithProgressBar.title = title;
        },
        updateSubtitleModalWithProgressBar: function(subtitle) {
            this.dataModalWithProgressBar.subtitle = subtitle;
        },
        updateProgressBar: function(progress) {
            this.dataModalWithProgressBar.progress = progress;
        },
        updateCloseModalWithProgressBar: function(withClose) {
            this.dataModalWithProgressBar.withClose = withClose;
        }
    },
  }
</script>

<style scoped>
.app-version {
    font-size: 0.7rem;
    line-height: 1.4;
    opacity: 0.7;
}
</style>

<style>
/* Make the sidebar content fill the full height so the build info
   (after .mt-auto) sits at the bottom. Covers both cases: before and
   after the simplebar library wraps the content. */
@media (min-width: 768px) {
    #sidebar .navbar-simplebar:not([data-simplebar="init"]),
    #sidebar .navbar-simplebar .simplebar-content {
        display: flex;
        flex-direction: column;
        min-height: 100%;
    }
}
</style>
